import { Config } from "./../../../Config";
import { FaceTecSDK } from "./../../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import type { FaceTecSessionResult, FaceTecFaceScanResultCallback, FaceTecFaceScanProcessor } from "./../../../../core-sdk/FaceTecSDK.js/FaceTecPublicApi";

export class LivenessCheckProcessor implements FaceTecFaceScanProcessor {
  latestNetworkRequest: XMLHttpRequest = new XMLHttpRequest();
  latestSessionResult: FaceTecSessionResult | null;
  success: boolean;
  sampleAppControllerReference: any;

  constructor(sessionToken: string, sampleAppControllerReference: any) {
    this.success = false;
    this.sampleAppControllerReference = sampleAppControllerReference;
    this.latestSessionResult = null;
    new FaceTecSDK.FaceTecSession(
      this,
      sessionToken
    );
  }

 
  public processSessionResultWhileFaceTecSDKWaits(sessionResult: FaceTecSessionResult, faceScanResultCallback: FaceTecFaceScanResultCallback) {

      this.latestSessionResult = sessionResult;

    if (sessionResult.status !== FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
      console.log("Session was not completed successfully, cancelling.  Session Status: " + FaceTecSDK.FaceTecSessionStatus[sessionResult.status]);
      this.latestNetworkRequest.abort();
      faceScanResultCallback.cancel();
      return;
    }

    var match3D = {
      imageFace: sessionResult.faceScan,
      imageAudit: sessionResult.auditTrail[0],
      imageLowQuality: sessionResult.lowQualityAuditTrail[0]
    };

    var token = localStorage.getItem("k_");    
    var auth = localStorage.getItem("auth_");
    this.latestNetworkRequest = new XMLHttpRequest();
    this.latestNetworkRequest.open("POST", Config.BaseURL + "/selfie/validate-facial");
    this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
    this.latestNetworkRequest.setRequestHeader("Authorization", auth ?? "");
    this.latestNetworkRequest.setRequestHeader("token", token ?? "");
    this.latestNetworkRequest.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
    this.latestNetworkRequest.setRequestHeader("X-User-Agent", FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId as string));

    this.latestNetworkRequest.onreadystatechange = () => {
      if (this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
        try {
          const res = JSON.parse(this.latestNetworkRequest.responseText);
          if (res.result) {
            FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage("Identidade\nConfirmada");
            this.success = true;
            faceScanResultCallback.succeed();
          }
          else {
            faceScanResultCallback.cancel();
          }
        }
        catch {
          faceScanResultCallback.cancel();
        }
      }
    };

    this.latestNetworkRequest.onerror = () => {
      faceScanResultCallback.cancel();
    };

  
    this.latestNetworkRequest.upload.onprogress = (event) => {

      var progress = event.loaded / event.total;
      faceScanResultCallback.uploadProgress(progress);
    };

    var jsonStringToUpload = JSON.stringify(match3D);
    this.latestNetworkRequest.send(jsonStringToUpload);

    window.setTimeout(() => {

      if (this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
        return;
      }
      faceScanResultCallback.uploadMessageOverride("Still Uploading...");
    }, 6000);
  }

  public onFaceTecSDKCompletelyDone = () => {
    this.sampleAppControllerReference.onComplete();

  }

  public isSuccess = () => {
    return this.success;
  }
}
